<template>
  <b-form class="survey-form">
    <b-container>
      <b-row class="border-bottom border-muted pb-3 pr-lg-3 py-2">
        <b-col lg="9" cols="9" class="pr-lg-4">
          <b-form-group label="Question" :label-for="`input-question-${index}`">
            <b-input
              :id="`input-question-${index}`"
              placeholder="Type your question here"
              required
              v-model="question.question"
              :maxlength="questionMaxLength"
              @keypress.native="filterAlphaNumericPunctuations"
              :readonly="isReadOnly"
              :state="isInvalid('question')"
            ></b-input>
            <b-form-invalid-feedback :state="isInvalid('question')">
              {{ errorMessage("question") }}
            </b-form-invalid-feedback>
             <slot name="image-render"></slot>
          </b-form-group>
        </b-col>
          <b-col lg="1" cols="1">
            <div :style="{ paddingBottom: '30px' }"></div> 
            <slot name="right-action-question-input"></slot>
        </b-col>
        <b-col lg="2" class="" v-if="isUcoin">
          <b-form-group label="Gigya Pairs" :label-for="`gigya-pairs-${index}`">
            <b-input
              v-model="question.gigya_question_id"
              type="text"
            ></b-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="px-3 pt-3 d-none d-lg-flex" v-if="elements.length">
        <b-col cols="4">
          <b-row>
            <b-col cols="4" class="pl-0"> Element </b-col>
            <b-col> Label </b-col>
          </b-row>
        </b-col>
        <b-col cols="3">
          <b-row>
            <b-col> Placeholder </b-col>
          </b-row>
        </b-col>
        <b-col cols="2" offset="1">
          <span class="mr-2"> Visible </span>
          <span> Required </span>
        </b-col>
        <b-col cols="2" v-if="isUcoin">
          <b-row>
            <b-col> Gigya Pairs </b-col>
          </b-row>
        </b-col>
      </b-row>
      <draggable
        :list="elements"
        draggable=".elements-draggable"
        handle=".handle"
        ghostClass="draggable-ghost"
        dragClass="draggable-ghost"
        @change="sortQuestionElements"
      >
        <b-row
          class="elements-draggable px-lg-3 py-2"
          v-for="(element, key) in elements"
          :key="key"
        >
          <b-col lg="4">
            <b-row>
              <b-col lg="4" class="pl-lg-0 pb-2 pb-lg-0 font-weight-bold">
                <span class="d-lg-none text-muted mr-1">Element: </span>
                <span :class="{ 'd-inline-block mb-4': element.type === 'Address' }">{{ element.type }}</span>
                <i
                  class="ic-tooltip ml-1 tooltip-primary-color"
                  v-if="element.type === 'Birthday'"
                  @click="
                    $root.$emit('bv::show::modal', 'birthday-preview-modal')
                  "
                ></i>
                <i
                  class="ic-tooltip ml-1 tooltip-primary-color"
                  v-if="element.type === 'Gender'"
                  @click="
                    $root.$emit('bv::show::modal', 'gender-preview-modal')
                  "
                ></i>
                <i
                  class="ic-tooltip ml-1 tooltip-primary-color"
                  v-if="element.type === 'Parenthood'"
                  @click="
                    $root.$emit('bv::show::modal', 'parenthood-preview-modal')
                  "
                ></i>
                <i
                  class="ic-tooltip ml-1 tooltip-primary-color"
                  v-if="element.type === 'Civil Status'"
                  @click="
                    $root.$emit('bv::show::modal', 'civil-status-preview-modal')
                  "
                ></i>
              </b-col>
              <b-col lg="8" v-if="element.type !== 'Address'">
                <b-input
                  :placeholder="element.type"
                  v-model="element.label"
                  required
                  :maxlength="maxCharacters"
                  :readonly="isReadOnly"
                  :state="
                    isInvalid(element.type.replace(/ /g, '_').toLowerCase())
                  "
                  @keypress.native="filterAlphaNumericPunctuations"
                />
                <b-form-invalid-feedback
                  :state="
                    isInvalid(element.type.replace(/ /g, '_').toLowerCase())
                  "
                >
                  {{
                    errorMessage(element.type.replace(/ /g, "_").toLowerCase())
                  }}
                </b-form-invalid-feedback>
              </b-col>
            </b-row>
            <!-- Start: Address Block - Label Column -->
            <template v-if="element.type === 'Address'">
              <b-row v-for="(address_option, addIndex) in element.options" :key="`address_option_label_${addIndex}`" class="py-2">
                <b-col lg="4" class="pl-lg-0 pb-2 pb-lg-0 font-weight-bold">
                  <span>{{ address_option.type }}</span>
                </b-col>
                <b-col lg="8">
                  <b-input
                    :placeholder="address_option.type"
                    v-model="address_option.label"
                    required
                    :maxlength="maxCharacters"
                    :readonly="isReadOnly"
                    :state="
                      isInvalid(address_option.type.replace(/ /g, '_').toLowerCase())
                    "
                    @keypress.native="filterAlphaNumericPunctuations"
                  />
                  <b-form-invalid-feedback :state="isInvalid(address_option.type.replace(/ /g, '_'))">
                    {{ errorMessage(address_option.type.replace(/ /g, "_").toLowerCase()) }}
                  </b-form-invalid-feedback>
                </b-col>
              </b-row>
            </template>
            <!-- End: Address Block - Label Column -->
          </b-col>
          <b-col :lg="elements.map(({ type }) => type).includes('Address') ? '2' : '3'" class="pt-3 pt-lg-0">
            <b-row v-if="element.type !== 'Address'">
              <b-col>
                <div class="d-lg-none font-weight-bold">Placeholder</div>
                <b-input
                  :placeholder="
                    element.type !== 'Birthday' && element.type !== 'Civil Status' && element.type !== 'Gender' && element.type !== 'Parenthood' && element.type !== 'Email Address' && element.type !== 'Contact No.'
                      ? `Enter your ${element.type.toLowerCase()} here`
                      : element.type === 'Email Address'
                        ? 'Enter your email here'
                        : element.type === 'Contact No.'
                          ? '09xxxxxxxxx'
                          : null
                  "
                  required
                  :disabled="element.isDisabled"
                  v-model="element.placeholder"
                  :maxlength="maxCharacters"
                  :readonly="isReadOnly"
                  @keypress.native="filterAlphaNumericPunctuations"
                />
              </b-col>
            </b-row>
            <template v-else> <!-- Start: Address Block - Placeholder Column -->
              <b-row class="py-2 mb-2">&nbsp;</b-row>
              <b-row v-for="(address_option, addressIndex) in element.options" :key="`address_option_placeholder_${addressIndex}`" class="py-2">
                <b-col>
                  <b-input
                    :placeholder="`Enter ${address_option.label}`"
                    required
                    v-model="address_option.placeholder"
                    :maxlength="maxCharacters"
                    :readonly="isReadOnly"
                    @keypress.native="filterAlphaNumericPunctuations"
                  />
                  <b-form-input type="text" hidden :state="isInvalid(address_option.type.replace(/ /g, '_').toLowerCase())"></b-form-input>
                  <b-form-invalid-feedback :state="isInvalid(address_option.type.replace(/ /g, '_').toLowerCase())">&nbsp;</b-form-invalid-feedback>
                </b-col>
              </b-row>
            </template>
            <!-- End: Address Block - Placeholder Column -->
          </b-col>
          <!-- Start: Address Block - Setting Icon for City and Province -->
          <b-col lg="1" class="px-0" v-if="elements.map(({ type }) => type).includes('Address')">
            <template v-if="element.type === 'Address'">
              <b-row class="py-2 mb-2">&nbsp;</b-row>
              <b-row
                :class="{ 'pt-1 pb-2': address_option.type === 'City' || address_option.type === 'Province', 'py-2': address_option.type !== 'City' || address_option.type === 'Province' }"
                v-for="(address_option, addressIndex) in element.options"
                :key="`address_option_setting_${addressIndex}`"
              >
                <i class="action-btn ml-3 mb-3" v-if="address_option.type === 'City' || address_option.type === 'Province'">
                  <img src="@/assets/images/settings-2.svg" alt="Settings" @click="showInputTypeModal(address_option)" />
                </i>
                <div v-else style="height: 39px;">&nbsp;</div>
                <b-form-input type="text" hidden :state="isInvalid(address_option.type.replace(/ /g, '_').toLowerCase())"></b-form-input>
                  <b-form-invalid-feedback :state="isInvalid(address_option.type.replace(/ /g, '_').toLowerCase())">&nbsp;</b-form-invalid-feedback>
              </b-row>
            </template>
          </b-col>
          <!-- End: Address Block - Setting Icon for City and Province -->
          <b-col
            lg="1"
            :class="['d-lg-flex flex-lg-row', { 'align-items-center text-center pt-2 pt-lg-0': element.type !== 'Address', 'mt-lg-1': element.type === 'Address' }]"
            :style="{ height: element.type === 'Address' ? 'fit-content' : null }"
            v-if="!isReadOnly"
          >
            <i class="action-btn handle mr-2">
              <img src="@/assets/images/actions/move-light.svg" alt="Move" />
            </i>
            <i
              class="action-btn"
              @click="showDeleteQuestionElementModal(key)"
              v-if="elements.length > 1"
            >
              <img src="@/assets/images/actions/delete_new.svg" alt="Delete" />
            </i>
          </b-col>
          <b-col lg="2" class="text-center text-lg-left">
            <b-checkbox
              v-model="element.visible"
              class="d-inline-block mt-2 mx-3"
              :disabled="isReadOnly"
            >
              <span class="d-lg-none">Visible</span>
            </b-checkbox>
            <b-checkbox
              v-model="element.required"
              class="d-inline-block custom-checkbox mt-2 mx-3"
              :disabled="isReadOnly"
            >
              <span class="d-lg-none">Required</span>
            </b-checkbox>
            <template v-if="element.type === 'Address'">
              <div v-for="(address_option, addressIndex) in element.options" :key="`address_option_visible_required_${addressIndex}`" class="py-1">
                <b-checkbox
                  v-model="address_option.visible"
                  class="d-inline-block mt-3 mx-3 "
                  :disabled="isReadOnly"
                >
                  <span class="d-lg-none">Visible</span>
                </b-checkbox>
                <b-checkbox
                  v-model="address_option.required"
                  class="d-inline-block mt-3 mx-3 custom-checkbox"
                  :disabled="isReadOnly"
                >
                  <span class="d-lg-none">Required</span>
                </b-checkbox>
                <b-form-input type="text" hidden :state="isInvalid(address_option.type.replace(/ /g, '_').toLowerCase())"></b-form-input>
                <b-form-invalid-feedback :state="isInvalid(address_option.type.replace(/ /g, '_').toLowerCase())">&nbsp;</b-form-invalid-feedback>
              </div>
            </template>
          </b-col>
          <b-col lg="2">
            <template v-if="element.type === 'Address'">
                <div style="margin-top: 45px;">
                  <div v-for="(address_option, addressIndex) in element.options" :key="`address_option_gigya_pair_${addressIndex}`" class="py-2">
                    <b-form-input type="text" v-model="address_option.gigya_answer_id" v-if="isUcoin"></b-form-input>
                  </div>
                </div>
            </template>
            <template v-else>
              <b-form-input type="text" v-model="element.gigya_answer_id" v-if="isUcoin"></b-form-input>
            </template>
          </b-col>
        </b-row>
      </draggable>

      <b-row class="mt-3" v-if="!isReadOnly">
        <b-col>
          <b-button
            :id="`add-field-btn-${index}`"
            variant="primary btn-add-link"
          >
            Add Field
          </b-button>
          <b-popover
            :target="`add-field-btn-${index}`"
            placement="top"
            container="survey-draggable-list"
            triggers="focus blur"
          >
            <b-container>
              <b-row>
                <b-col
                  v-for="(field, key) in fields"
                  :key="key"
                  class="col-6"
                  @click.self="
                    $root.$emit('contact-add-field', {
                      type: field,
                      pageIndex: index.split('-')[0],
                      questionIndex: index.split('-').pop(),
                      question_type: question.question_type,
                      question_uuid: question.uuid,
                    });
                    $root.$emit('bv::hide::popover');
                  "
                >
                  {{ field }}
                </b-col>
              </b-row>
            </b-container>
          </b-popover>
        </b-col>
      </b-row>
      <b-row class="mt-3 pt-3 border-top border-muted">
        <b-col lg="3" class="ml-auto">
          <div class="d-flex flex-row justify-content-end">
            <b-button
              variant="link"
              class="text-danger font-weight-bold mr-2"
              @click.self="showConfirmCancelQuestionModal"
              :disabled="isReadOnly"
            >
              Cancel
            </b-button>
            <b-button
              variant="primary btn-save"
              :disabled="isLoading || isReadOnly"
              @click.self="validateFields"
            >
              Save
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </b-form>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import draggable from "vuedraggable";
import notification from "@/services/notification";

export default {
    name: "ContactDetailsForm",
    data() {
        return {
            elementId: null,
            fields: [
                "Full Name",
                "Civil Status",
                "First Name",
                // "Province",
                "Address",
                "Last Name",
                // "City",
                "Birthday",
                "Email Address",
                // "Zip Code",
                "Contact No.",
                "Custom Fields",
                "Gender",
                "Parenthood"
            ],
            questionMaxLength: 350,
            maxCharacters: 30
        };
    },
    computed: {
        ...mapGetters("surveys", [
            "isLoading",
            "errors",
            "isReadOnly",
            "survey",
            "isUcoin"
        ])
    },
    props: ["pageId", "question", "elements", "index"],
    methods: {
        ...mapMutations("surveys", [
            "setQuestionProperties",
            "setStringifyContent",
            "setErrors"
        ]),
        validateFields() {
            const errors = {};
            if (!this.question.question)
                errors["question"] = "Question is required";

            if (
                this.question.question &&
                this.isNotAlphaNumericPunctuations(this.question.question)
            ) {
                errors["question"] =
                    "Only alpha numeric with punctuation characters are allowed";
            }

            this.question.contents.elements.map(field => {
                if (!field.label)
                    errors[field.type.replace(/ /g, "_").toLowerCase()] =
                        "Label is required";

                if (
                    field.label &&
                    this.isNotAlphaNumericPunctuations(field.label)
                ) {
                    errors[field.type.replace(/ /g, "_").toLowerCase()] =
                        "Only alpha numeric with punctuation characters are allowed";
                }

                if (field.type === "Address")
                    field.options.map(addOption => {
                        if (!addOption.label)
                            errors[
                                addOption.type.replace(/ /g, "_").toLowerCase()
                            ] =
                                "Label is required";
                    });
            });
            this.setErrors(errors);
            if (Object.keys(errors).length === 0)
                this.showConfirmSaveQuestionModal();
            else notification.warning("Oops, cannot save question.");
        },
        showDeleteQuestionElementModal(elementIndex) {
            this.setQuestionProperties({
                pageIndex: this.index.split("-")[0],
                questionIndex: this.index.split("-").pop(),
                elementIndex: elementIndex,
                page_uuid: this.pageId,
                question_uuid: this.question.uuid,
                question_type: this.question.question_type
            });
            this.$root.$emit(
                "bv::show::modal",
                "delete-question-element-modal"
            );
        },
        showConfirmSaveQuestionModal() {
            this.setQuestionProperties({
                type: "save",
                pageIndex: this.index.split("-")[0],
                questionIndex: this.index.split("-").pop(),
                question_type: "contact_details",
                page_uuid: this.pageId,
                question_uuid: this.question.uuid
            });
            this.$root.$emit(
                "bv::show::modal",
                "confirm-save-cancel-question-modal"
            );
        },
        showConfirmCancelQuestionModal() {
            this.setQuestionProperties({
                type: "cancel",
                pageIndex: this.index.split("-")[0],
                questionIndex: this.index.split("-").pop(),
                question_type: "contact_details",
                page_uuid: this.pageId,
                question_uuid: this.question.uuid
            });
            this.$root.$emit(
                "bv::show::modal",
                "confirm-save-cancel-question-modal"
            );
        },
        showInputTypeModal(option) {
            this.setQuestionProperties({
                option: option,
                page_uuid: this.pageId,
                question_uuid: this.question.uuid,
                questionIndex: this.index.split("-").pop()
            });
            this.$root.$emit(
                "bv::show::modal",
                `${option.type.toLowerCase()}-input-type-modal`
            );
        },
        isNotAlphaNumericPunctuations(input) {
            return /[^A-Za-z0-9 ,.!?'":()\s\-]+/g.test(input);
        },
        filterAlphaNumericPunctuations(e) {
            if (
                this.isNotAlphaNumericPunctuations(
                    String.fromCharCode(e.keyCode)
                )
            )
                e.preventDefault();
        },
        isInvalid(field) {
            if (this.errors === null) {
                return null;
            } else {
                return !Object.keys(this.errors).includes(field)
                    ? null
                    : !Object.keys(this.errors).includes(field);
            }
        },
        errorMessage(field) {
            if (this.errors === null) {
                return "";
            } else if (Object.keys(this.errors).includes(field)) {
                return Array.isArray(this.errors[field])
                    ? this.errors[field].join(" ")
                    : this.errors[field];
            }
        },
        sortQuestionElements() {
            const stringifyContent = {
                page_index: this.index.split("-")[0],
                question_type: this.question.question_type
            };
            if (this.question.uuid)
                stringifyContent["question_uuid"] = this.question.uuid;
            else
                stringifyContent["question_index"] = this.index
                    .split("-")
                    .pop();

            this.setStringifyContent(stringifyContent);
        }
    },
    components: {
        draggable
    }
};
</script>

<style>
.tooltip-primary-color {
    background: transparent url("../../../assets/images/tooltip-orange.svg")
        no-repeat center/15px !important;
}
</style>
